import {
  setRecentlyPlayedContext,
  setRecentlyPlayedError,
  setRecentlyPlayedStatus,
} from '@/store/actions';
import { emptySliceError } from '@/store/slices/sliceError';
import { RecentlyPlayedItem } from '@/store/slices/recentlyPlayed/recentlyPlayed';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';

/**
 * Handler for recently played data
 * Updates the store with fetched recently played games
 */
const handleRecentlyPlayedData = (data: RecentlyPlayedItem[]) => {
  const recentlyPlayedData = data || [];

  setRecentlyPlayedContext({
    recentlyPlayed: recentlyPlayedData,
  });
  setRecentlyPlayedStatus({ loading: false });
  setRecentlyPlayedError(emptySliceError());

  Logger.logRumAction({
    name: '[GW][GET_RECENTLY_PLAYED] Received',
    useCase: DdEventCategory.Initialization,
    eventType: DdEventType.Success,
    context: {
      count: recentlyPlayedData.length,
    },
  });
};

export default handleRecentlyPlayedData;
